var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDiagram(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 412,
    height: 240,
    viewBox: "0 0 412 240",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 412,
    height: 240,
    fill: "var(--card-thumbnail-bg)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M197.667 36.6666V203.333C155.167 199.167 122.667 163.333 122.667 120C122.667 76.6666 155.167 40.8333 197.667 36.6666ZM214.333 36.6666V111.667H289.333C285.167 71.6666 254.333 40.8333 214.333 36.6666ZM214.333 128.333V203.333C253.5 199.167 285.167 168.333 289.333 128.333H214.333Z",
    fill: "var(--card-thumbnail-fg)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiagram);
export default __webpack_public_path__ + "static/media/diagram.bb63f06987cf62dec9c555a96b2d7333.svg";
export { ForwardRef as ReactComponent };